import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import './shell.css';

/**
 * The authenticated application frame: left rail + sticky top bar + canvas.
 * Responsive behaviour (rail collapses to a horizontal strip under 860px)
 * lives in ui.css / shell.css.
 *
 * COMPACT RAIL
 * A few screens are board-shaped: they need the horizontal room far more
 * than they need a labelled navigation column. Those routes are listed in
 * COMPACT_ROUTES and the shell reads the current location itself, so no
 * screen has to pass a prop and no other screen changes at all.
 */
const COMPACT_ROUTES = ['/field'];

function isCompactRoute(pathname) {
  const path = String(pathname || '').toLowerCase();
  return COMPACT_ROUTES.some(route => path === route || path.indexOf(route + '/') === 0);
}

export default function AppShell({ title, eyebrow, children }) {
  const location = useLocation();
  const compact = isCompactRoute(location.pathname);

  return (
    <div className={compact ? 'shell shell-compact' : 'shell'}>
      <Sidebar compact={compact} />
      <div className="main">
        <TopBar title={title} eyebrow={eyebrow} />
        <main className="canvas">{children}</main>
      </div>
    </div>
  );
}
